module.exports = __webpack_public_path__ + "static/img/032 31.8537c998.jpg";